(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxSearchQueryConditionOperator', {
		bindings: {
			model: '=ngModel',
			conditionOperators: '=items',
		},
		controller: MxSearchQueryConditionOperatorCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-search-query-condition/mx-search-query-condition-operator.html',
	});

	MxSearchQueryConditionOperatorCtrl.$inject = ['$scope', 'mx.sb.Agent.DataQuery.FilterOperatorsFactory'];

	function MxSearchQueryConditionOperatorCtrl($scope, filterOperatorsFactory) {
		var vm = this;

		vm.openDropDown = openDropDown;

		vm.$onInit = function () {
			vm.showDropDown = false;
			vm.conditionOperatorsDropdownList = [];

			if (vm.model !== undefined) {
				const operator = filterOperatorsFactory.getOperatorByValue(vm.model);
				if (operator) {
					vm.operator = operator;
				}
			}
		};

		var watcher = $scope.$watch('vm.conditionOperators', function () {
			if (Array.isArray(vm.conditionOperators)) {
				vm.conditionOperatorsDropdownList = vm.conditionOperators
					.filter(function (op) {
						return op;
					})
					.map(function (op) {
						return {
							label: op.name,
							onItemClick: function () {
								choose(op);
							},
						};
					});
			}
		});

		$scope.$on('$destroy', function () {
			watcher();
		});

		return vm;

		function choose(operator) {
			vm.operator = operator;
			vm.model = operator.value;
		}

		function openDropDown($event) {
			$event.stopPropagation();
			vm.showDropDown = true;
		}
	}
})();
